import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable } from 'rxjs';
import { ApplicationApiUrls } from 'src/app/constants/api-url-constants';
import { ListingResponse } from 'src/app/models/listing-model/listing-response.model';
import { SinglePropertyResponse } from 'src/app/models/listing-model/single-property.model';
import { GetListingRequest } from 'src/app/models/request-models/get-listing.request';
import { PropertyProfileStatusRequest } from 'src/app/models/request-models/property-profile-status-request';
import { ApiResponse } from 'src/app/models/response-model/api-response';
import { BaseGridResponse } from 'src/app/models/response-model/base-grid-response';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../loader-service/loader.service';

@Injectable({
  providedIn: 'root',
})
export class ListingApiService {
  private apiUrl = environment.apiUrl;
  listOfProperties = new BehaviorSubject<SinglePropertyResponse[]>([]);
  isUserLoggedIn = new BehaviorSubject<boolean>(false);
  isMapUi = new BehaviorSubject<boolean>(false);
  currentSelectedCityInfo = new BehaviorSubject<any>({});
  currentActiveModel = new BehaviorSubject<string>('');
  isStreetViewVisible = new BehaviorSubject<{
    visible?: boolean;
    lat?: number;
    long?: number;
  }>({});

  constructor(
    private http: HttpClient,
    public loaderService: LoaderService,
  ) {}

  AddListing(request: FormData): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}${ApplicationApiUrls.AddListing}`, request).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  saveAsDraft(request: FormData): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}${ApplicationApiUrls.SaveAsDraft}`, request).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  updateDraft(request: FormData): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}${ApplicationApiUrls.UpdateDraft}`, request).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  EditListing(request: FormData): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}${ApplicationApiUrls.AddListing}`, request).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  GetListings(request: GetListingRequest): Observable<BaseGridResponse<ListingResponse[]>> {
    this.loaderService.setLoading(true);
    delete request.pageNumber;
    delete request.pageSize;
    return this.http.post(`${this.apiUrl}${ApplicationApiUrls.GetListings}`, request).pipe(
      map((data: BaseGridResponse<ListingResponse[]>) => {
        this.loaderService.setLoading(false);
        return data;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  GetPropertyProfileById(request: number): Observable<SinglePropertyResponse> {
    return this.http
      .get(`${this.apiUrl}${ApplicationApiUrls.GetPropertyProfileById}${request}`)
      .pipe(
        map((data: ApiResponse<SinglePropertyResponse>) => {
          return data.result!;
        }),
        catchError((err) => {
          throw err;
        }),
      );
  }

  SetPropertyProfileStatus(id: number, request: PropertyProfileStatusRequest): Observable<any> {
    const url = `${this.apiUrl}${ApplicationApiUrls.SetPropertyProfileStatus.replace('{id}', id.toString())}`;
    return this.http.patch(url, request).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  DeleteProperty(propertyId: number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}${ApplicationApiUrls.DeleteProperty}/${propertyId}`, { body: { id: propertyId } })
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((err) => {
          throw err;
        }),
      );
  }
}
